import { createFileRoute, redirect } from "@tanstack/react-router"

// The actions overview merged into the actions step; old links still land there.
export const Route = createFileRoute("/(authenticated)/bulk-updates/$changeProjectId/actions")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/bulk-updates/$changeProjectId/define",
      params: { changeProjectId: params.changeProjectId },
    })
  },
})
